import React from 'react';
import { Phone, Mail } from 'lucide-react';

interface ContactInformationProps {
  data: {
    primaryContactName: string | null;
    jobTitle: string | null;
    primaryEmail: string | null;
    phoneNumber: string | null;
    claimsEmail: string | null;
    supportEmail: string | null;
    emergencyPhone: string | null;
  };
  isEditing: boolean;
  onUpdate: (field: string, value: string) => void;
}

export function ContactInformation({ data, isEditing, onUpdate }: ContactInformationProps) {
  return (
    <section className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-medium text-gray-900 flex items-center mb-4">
        <Phone className="h-5 w-5 text-indigo-600 mr-2" />
        Contact Information
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {isEditing ? (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700">Primary Contact Name</label>
              <input
                type="text"
                value={data.primaryContactName || ''}
                onChange={(e) => onUpdate('primaryContactName', e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Job Title</label>
              <input
                type="text"
                value={data.jobTitle || ''}
                onChange={(e) => onUpdate('jobTitle', e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Primary Email</label>
              <input
                type="email"
                value={data.primaryEmail || ''}
                onChange={(e) => onUpdate('primaryEmail', e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Phone Number</label>
              <input
                type="tel"
                value={data.phoneNumber || ''}
                onChange={(e) => onUpdate('phoneNumber', e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Claims Email</label>
              <input
                type="email"
                value={data.claimsEmail || ''}
                onChange={(e) => onUpdate('claimsEmail', e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Support Email</label>
              <input
                type="email"
                value={data.supportEmail || ''}
                onChange={(e) => onUpdate('supportEmail', e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Emergency Phone</label>
              <input
                type="tel"
                value={data.emergencyPhone || ''}
                onChange={(e) => onUpdate('emergencyPhone', e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
          </>
        ) : (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-500">Primary Contact</label>
              <p className="mt-1 text-sm text-gray-900">{data.primaryContactName}</p>
              <p className="text-sm text-gray-500">{data.jobTitle}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-500">Primary Email</label>
              <p className="mt-1 text-sm text-gray-900">{data.primaryEmail}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-500">Phone Number</label>
              <p className="mt-1 text-sm text-gray-900">{data.phoneNumber}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-500">Emergency Phone</label>
              <p className="mt-1 text-sm text-gray-900">{data.emergencyPhone}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-500">Claims Email</label>
              <p className="mt-1 text-sm text-gray-900">{data.claimsEmail}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-500">Support Email</label>
              <p className="mt-1 text-sm text-gray-900">{data.supportEmail}</p>
            </div>
          </>
        )}
      </div>
    </section>
  );
}